module.exports = __webpack_public_path__ + "img/home_phone_banner1.aa955f52.png";